<script>
  import Markdown from "svelte-exmarkdown";
  import { gfmPlugin } from "svelte-exmarkdown/gfm";

  export let md;
</script>

<div class="md-container">
  <Markdown {md} plugins={[gfmPlugin]} />
</div>

<style>
  .md-container {
    border: 1px solid #ccc;
    padding: 12px;
    border-radius: 5px;
  }
</style>
